import React from "react";
import { sbEditable } from "@storyblok/storyblok-editable";
import Slideshow from "../sections/Generic/Slideshow";
import TextWithCursor from "../sections/Generic/TextWithCursor";
import HomeWork from "../sections/Home/Work";
import FullWidthImage from "../sections/Generic/FullWidthImage";
import ServicesBreakdown from "../sections/Services/ServicesBreakdown";
import ContactFormSection from "../sections/Generic/Contact";
import OurTeam from "../sections/OurTeam";
import InsetTextTitle from "../sections/Generic/InsetTextTitle";
import AllWork from "../sections/Work/AllWork";
import ImageWithText from "../sections/Generic/ImageWithText";
import ImageGrid from "../sections/Generic/ImageGrid";
import Quote from "../sections/Generic/Quote";
import ProjectScopeCopy from "../sections/Work/ProjectScopeCopy";
import AllBlog from "../sections/Blog/AllBlog";
import BlogHero from "../sections/Blog/BlogHero";
import BlogContent from "../sections/Blog/BlogContent";
import NumberedCopyImage from "../sections/Generic/NumberedCopyImage";
import ServiceHero from "../sections/Services/ServiceHero";
import CopyBlock from "../sections/Generic/CopyBlock";
import ImageWithTitleGrid from "../sections/Generic/ImageWithTitleGrid";
import ProjectGrid from "../sections/Work/ProjectGrid";
import HtmlEmbed from "./HtmlEmbed";
import EmbeddedEmailSignup from "./EmbeddedEmailSignup";


const Components = {
  "slideshow": Slideshow,
  "text_with_cursor": TextWithCursor,
  "work_home": HomeWork,
  "full_width_image": FullWidthImage,
  "services_breakdown": ServicesBreakdown,
  "contact_form": ContactFormSection,
  "our_team": OurTeam,
  "inset_text_and_title": InsetTextTitle,
  "all_work": AllWork,
  "image_with_text": ImageWithText,
  "image_grid": ImageGrid,
  "quote_block": Quote,
  "project_scope_copy": ProjectScopeCopy,
  "all_blog": AllBlog,
  "blog_hero": BlogHero,
  "blog_content": BlogContent,
  "numbered_copy_image": NumberedCopyImage,
  "service_hero": ServiceHero,
  "copy_block": CopyBlock,
  "image_with_title_grid": ImageWithTitleGrid,
  "project_grid": ProjectGrid,
  "html_embed": HtmlEmbed,
  "embedded_email_signup": EmbeddedEmailSignup
};

const DynamicComponent = ({ blok, componentType }) => {

  const component = blok?.component || componentType

  if (typeof Components[component] !== "undefined") {
    const Component = Components[component];
    return (
      <div
        {...sbEditable(blok)}
        className="h-full w-full"
      >
        <Component blok={blok} />
      </div>
    );
  }
  return (
    <p>
      The component <strong>{component}</strong> has not been created yet.
    </p>
  );
};

export default DynamicComponent;
